import { combineReducers } from 'redux';

import type { AsyncActionStatus } from '../actions/common.actionTypes';
import aiAssistant, { type AIAssistantState } from './aiAssistant.reducers';
import aiFilterValues, { type AiFilterValuesState } from './aiFilterValues.reducers';
import collections, { type CollectionsInitialStateType } from './collections.reducers';
import courses, { type CourseState } from './courses.reducers';
import dashboard, { type DashboardInitialStateType } from './dashboard.reducers';
import download, { type DownloadInitialStateType } from './download.reducers';
import errors, { type ErrorsState } from './errors.reducers';
import lernsets, { type LernsetsState } from './lernsets.reducers';
import licenceModels, { type LicenceModelsStateType } from './licenceModels.reducers';
import mindItems, { type MindItemState } from './mindItems.reducers';
import pinned, { type PinnedInitialStateType } from './pinned.reducers';
import products, { type ProductState } from './products.reducers';
import publishers, { type PublisherState } from './publishers.reducers';
import recentlyViewed, { type RecentlyViewedInitialStateType } from './recentlyViewed.reducers';
import schoolTypes, { type SchoolTypeState } from './schoolTypes.reducers';
import search, { type SearchInitialStateType } from './search.reducers';
import upgradeCodes, { type UpgradeCodeState } from './upgradeCodes.reducers';
import user, { type UserInitialStateType } from './user.reducers';

export type StoreItem<T> = {
	data?: T;
	status: AsyncActionStatus;
	error?: string;
};

export interface StoreType {
	collections: CollectionsInitialStateType;
	courses: CourseState;
	dashboard: DashboardInitialStateType;
	download: DownloadInitialStateType;
	errors: ErrorsState;
	licenceModels: LicenceModelsStateType;
	mindItems: MindItemState;
	upgradeCodes: UpgradeCodeState;
	pinned: PinnedInitialStateType;
	products: ProductState;
	recentlyViewed: RecentlyViewedInitialStateType;
	publishers: PublisherState;
	schoolTypes: SchoolTypeState;
	aiFilterValues: AiFilterValuesState;
	search: SearchInitialStateType;
	user: UserInitialStateType;
	lernsets: LernsetsState;
	aiAssistant: AIAssistantState;
}

export default combineReducers<StoreType>({
	collections,
	courses,
	dashboard,
	download,
	errors,
	licenceModels,
	mindItems,
	upgradeCodes,
	pinned,
	products,
	recentlyViewed,
	schoolTypes,
	aiFilterValues,
	search,
	publishers,
	user,
	lernsets,
	aiAssistant,
});
